import { RouteRecordRaw } from 'vue-router';
import { IRouteConfigAuthMeta } from '@/shared';

const auth: IRouteConfigAuthMeta = {
  required: false,
};

export default [
  {
    path: '/payments',
    name: 'payments',
    component: () => import('@/views/payments/PaymentStatus.vue'),
    meta: {
      auth,
      title: 'Payment',
      active: false,
      hideBlade: true,
    },
  },
] as RouteRecordRaw[];
